var map = {
	"./10_club.png": 44,
	"./10_diamond.png": 45,
	"./10_heart.png": 46,
	"./10_spade.png": 47,
	"./1_club.png": 48,
	"./1_diamond.png": 49,
	"./1_heart.png": 50,
	"./1_spade.png": 51,
	"./2_club.png": 52,
	"./2_diamond.png": 53,
	"./2_heart.png": 54,
	"./2_spade.png": 55,
	"./3_club.png": 56,
	"./3_diamond.png": 57,
	"./3_heart.png": 58,
	"./3_spade.png": 59,
	"./4_club.png": 60,
	"./4_diamond.png": 61,
	"./4_heart.png": 62,
	"./4_spade.png": 63,
	"./5_club.png": 64,
	"./5_diamond.png": 65,
	"./5_heart.png": 66,
	"./5_spade.png": 67,
	"./6_club.png": 68,
	"./6_diamond.png": 69,
	"./6_heart.png": 70,
	"./6_spade.png": 71,
	"./7_club.png": 72,
	"./7_diamond.png": 73,
	"./7_heart.png": 74,
	"./7_spade.png": 75,
	"./8_club.png": 76,
	"./8_diamond.png": 77,
	"./8_heart.png": 78,
	"./8_spade.png": 79,
	"./9_club.png": 80,
	"./9_diamond.png": 81,
	"./9_heart.png": 82,
	"./9_spade.png": 83,
	"./back-aqua.png": 84,
	"./back-black.png": 85,
	"./back-blue.png": 86,
	"./back-fuchsia.png": 87,
	"./back-gray.png": 88,
	"./back-green.png": 89,
	"./back-lime.png": 90,
	"./back-maroon.png": 91,
	"./back-navy.png": 92,
	"./back-olive.png": 93,
	"./back-purple.png": 94,
	"./back-red.png": 95,
	"./back-silver.png": 96,
	"./back-teal.png": 97,
	"./back-yellow.png": 98,
	"./back.png": 99,
	"./black_joker.png": 100,
	"./blank_club.png": 101,
	"./blank_diamond.png": 102,
	"./blank_heart.png": 103,
	"./blank_spade.png": 104,
	"./card-base.png": 105,
	"./jack_club.png": 106,
	"./jack_diamond.png": 107,
	"./jack_heart.png": 108,
	"./jack_spade.png": 109,
	"./king_club.png": 110,
	"./king_diamond.png": 111,
	"./king_heart.png": 112,
	"./king_spade.png": 113,
	"./queen_club.png": 114,
	"./queen_diamond.png": 115,
	"./queen_heart.png": 116,
	"./queen_spade.png": 117,
	"./red_joker.png": 118,
	"./suit-club.png": 119,
	"./suit-diamond.png": 120,
	"./suit-heart.png": 121,
	"./suit-spade.png": 122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43;